module.exports = __webpack_public_path__ + "static/media/packet_loss.bb8ce171.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Lag/images/animations/packet_loss.png
// module id = 1490
// module chunks = 39